import React, { Component } from 'react';
import { Row, Col, Card, Container } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import CreateQuizSection from './create_quiz/CreateQuizSection';
import ManageQuizSection from './manage_quiz/ManageQuizSection';
import './_quiz.scss';
import QuizsummarySection from './quiz_summary/QuizsummarySection';

class QuizHomeSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            blockType: "createExam"
        }
    }

    handleSelect(val) {
        this.setState({
            blockType: val
        })
    }



    render() {
        
        console.log("aaaa",this.props)
        return (
            <section className='quiz_section'>
                <Container fluid>
                    <Row>
                        <Col sm={4} className='mt-3 mb-3'>
                        <Card className={this.state.blockType == "createExam" ? "active block_view" : " block_view"} onClick={() => this.handleSelect("createExam")}>
                            <Card.Body>
                                <h5 className="text-center color_blue"><img className="mr-2"  src={require('../../../images/create_quiz_blue.png')}  alt="Create_Quiz"/> <span className='title_alignment'>Create Quiz</span></h5>
                                <Card.Text className='mt-4 f-16'>
                                    For a given topic / topics in a subject create 15 Mins or 30 Mins Quiz, publish the quiz to selected sections in a class.
                                </Card.Text>
                                
                            </Card.Body>
                            </Card>
                        </Col>
                        <Col sm={4} className='mt-3 mb-3'>
                            <Card className={this.state.blockType == "scheduledQuiz" ? "active block_view" : " block_view"} onClick={() => this.handleSelect("scheduledQuiz")}>
                                <Card.Body>
                                    <h5 className="text-center color_blue"><img className="mr-2"  src={require('../../../images/manage_quiz_blue.png')}  alt="Manage_Quiz"/> <span className='title_alignment'>Manage Quiz</span></h5>
                                    <Card.Text className='mt-4 f-16 pad_bot_25'>
                                        Already Created Draft, Scheduled, Live Exams Management. Draft Exams can be scheduled.
                                    </Card.Text>
                                    
                                </Card.Body>
                            </Card>

                        </Col>
                        <Col sm={4} className='mt-3 mb-3'>
                            <Card className={this.state.blockType == "quizSummary" ? "active block_view" : " block_view"} onClick={() => this.handleSelect("quizSummary")}>
                                <Card.Body>
                                    <h5 className="text-center color_blue"><img className="mr-2"  src={require('../../../images/quiz_summary_blue.png')}  alt="Quiz_summary"/> <span className='title_alignment'>Quiz Summary</span></h5>
                                    <Card.Text className='mt-4 f-16 pad_bot_25'>
                                         Already completed quiz summary for each <br/>quiz wise.
                                    </Card.Text>
                                    
                                </Card.Body>
                            </Card>
                           
                        </Col>
                    </Row>
                   
                        {
                            this.state.blockType === "createExam"
                                ? <CreateQuizSection globals={this.props.globals} getSections ={this.props.getSections} />
                                : this.state.blockType === "scheduledQuiz"
                                ? <ManageQuizSection globals={this.props.globals} savedPapers={this.props.savedPapers} scheduledQuiz={this.props.scheduledQuiz}/>
                                : this.state.blockType === "quizSummary" 
                                ? <QuizsummarySection  globals={this.props.globals} getQuizCompletedExams={ this.props.getQuizCompletedExams}/> : ""
                                
                                
                        }

                </Container>
            </section>
        )
    }
}

export default QuizHomeSection;
